<script lang="ts">
    import { setContext, getContext } from 'svelte';
    import { addDays, addHours, endOfDay, isToday, startOfDay } from 'date-fns';
    import ActivityEdit from './ActivityEdit.svelte';
    import { getRequest, toTimeInputString, toTimeInputStringHours, combineDateTime, toDateInputString, fetchTrainingAdvice, debouncer, dispatchReloadEvent, isActivityCompleted, round, type XSSDetails, generateMagicIntervals as _generateMagicIntervals, targetsLowIntensity, xssToFocusSpecificity, getEnduranceDurationDifficulty, kmToUserDistanceUnits, userDistanceUnitsToKm, forecastTargetsApplyOn} from '@/Util/utils';
    import type { MedianAndWeatherStores, MyFitnessStores } from '../stores';
    import RecommendedTraining from '../RecommendedTraining.svelte';
    import XataTrainingStatus from '../XataTrainingStatus.svelte';
    import XataContent from '../XataContent.svelte';
    import XssDeficitGauge from '../XssDeficitGauge.svelte';
    import XataSlider from '../XataSlider.svelte';
    import Weather from './Weather.svelte';
    import TrainingStatus from '../TrainingStatus.svelte';
    import ForecastDescription from '../../Common/ForecastDescription.svelte';
    import { _ } from 'svelte-i18n';
    import TrainingUpcomingCards from '../TrainingForecast/TrainingUpcomingCards.svelte';
    import XssSummary from '../Today/XssSummary.svelte';
    import { type SPFocus, populateForecast, deleteCalendarEvent, autoGenWorkout, type XSSTargetsResponse } from '@/Util/api';
    import { type ForecastActivityState, type MagicBucketsType, toggledRestActivityBody, ReccTrainingPills } from '@/Common/constants';
    import { LocalDate } from '@/time';
    import { type Writable, writable } from 'svelte/store';
    import * as Sheet from "$lib/components/ui/sheet";
    import * as Tabs from "$lib/components/ui/tabs";
    import { cn } from '@/lib/utils';
    import Button from '@/lib/components/ui/button/button.svelte';
    import Label from '@/lib/components/ui/label/label.svelte';
    import Input from '@/lib/components/ui/input/input.svelte';
    import { Skeleton } from "$lib/components/ui/skeleton/index.js";
    import { Activity } from '@/Common/ActivityFunctions';
    import MagicBucketsWorkout from '../MagicBuckets/MagicBucketsWorkout.svelte';
    import { MagicBucketsFieldsAndData } from '../MagicBuckets/MagicBucketsFieldsAndData';

    export let myFitness: MyFitnessStores;
    export let activity_types;
    export let likeScore: number;
    export let dislikeScore: number;
    export let athlete: any = null;
    export let workout_description: any = null;
    export let program_weeks;
    export let challenge_days;
    export let weather;
    export let sport_type: string;
    export let root: HTMLElement;
    export let xssTargetsResponse: XSSTargetsResponse = null;
    
    const { trainingPlan, userParams } = myFitness
    const { trainingMedians } = getContext<MedianAndWeatherStores>('medianAndWeather')

    //@ts-ignore
    const Xert = window.Xert

    // TODO: Remove I don't think these are being used at all
    let exercise = null;
    //-------------

    let dateTime: Date;
    let originalDate: Date = null; // original date of an activity if in editing mode
    let open = false
    let past: boolean; 
    let selected_exercise = null;
    let selected_path = null;
    let canSubmit = false;
    let editingMode = false;
    let editExercisePath;
    let hasPowerData = true
    let restToggleState: boolean

    let activityFormValid = false;
    let manualExercisePath;
    let manualExerciseDistance;
    let manualExerciseDuration;
    let manualExerciseName;
    let manualExerciseFocus;
    let manualExerciseSfd;
    let manualExerciseDesc;
    let manualExerciseSpr;
    let manualExerciseSp;
    let manualExerciseXss;
    let manualExerciseXlss;
    let manualExerciseXhss;
    let manualExerciseXpss;

    let activityType = sport_type;
    let inputDate: string, inputTime: string;
    let isAdditionalTraining = true;
    let setIsLoading = (v) => {}

    // Different modes
    type EntryModes = "activity" | "magic" | "manual" | "workout"
    let chosenEntryTab: EntryModes = "activity"
    $: entryModeTabs = (editingForecast
        ? [
            {label: "Workout", value: "workout"},
            {label: "Activity", value: "activity"},
            {label: "Generate Workout", value: "magic"},
            {label: "Manual", value: "manual"},
        ]
        : [
            {label: "Activity", value: "activity"},
            {label: "Generate Workout", value: "magic"},
            {label: "Manual", value: "manual"},
        ]) as {label: string, value: EntryModes}[]

    // Forecast XSS targets apply when the plan is active, or on/after the start date of a plan that hasn't started
    // yet (Pre-Plan Maintenance: XATA targets are used for dates before the start date).
    const usesForecastTargets = (date = dateTime) => forecastTargetsApplyOn($trainingPlan, date)
    $: forecastTargets = forecastTargetsApplyOn($trainingPlan, dateTime)

    // Fetching and updating the training advice depending on the date / time
    let trainingAdvicePromise: Promise<any> = new Promise(()=>{})
    let trainingAdviceAtDate: any
    const dateDebouncer = debouncer(250)
    const executeDateDebouncer = () => dateDebouncer.debounce(()=>onDateChange(inputDate, inputTime))

    async function updateMagicBucketsTargets() {
        if(!useMagicBuckets) return

        let isEditingToday = isToday(dateTime)
        if (isEditingToday && xssTargetsResponse) magicBucketsFieldsAndData.updateTargets(xssTargetsResponse.remainingTargetsNumeric)
        if(!usesForecastTargets()) {
            magicBucketsFieldsAndData.signature = trainingAdviceAtDate.signature
            if (!xssTargetsResponse || !isEditingToday) {
              magicBucketsFieldsAndData.updateTargets({
                  xss: trainingAdviceAtDate.xss_goal,
                  ...trainingAdviceAtDate.targetXSS
              })
            }
            magicBucketsFieldsAndData.recommendedWorkoutDuration = (trainingAdviceAtDate.availability ?? 0)*3600.0
        } else {
            magicBucketsFieldsAndData.signature = $activityContext.signature

            if (!xssTargetsResponse || !isEditingToday) {
              let xssTargets = (!($activityContext.state?.includes('xssOverride')) && $activityContext.placeholder_xss_details != null)
                  ? $activityContext.placeholder_xss_details
                  : {xss: $activityContext.xss, xlss: $activityContext.xlss, xhss: $activityContext.xhss, xpss: $activityContext.xpss}
  
              magicBucketsFieldsAndData.updateTargets(xssTargets)
            }
            magicBucketsFieldsAndData.recommendedWorkoutDuration = ($activityContext.duration ?? 0);
        }

        targetsAreLowIntensity = targetsLowIntensity(magicBucketsFieldsAndData.targets)
        if(targetsAreLowIntensity) magicBucketsType = "autogen"  
    }

    let refreshTrainingAdvice = async() => {
        return fetchTrainingAdvice(dateTime, sport).then(res => {
            trainingAdviceAtDate = res
            updateMagicBucketsTargets()
            return res
        })
    }

    async function onDateChange(inputDate, inputTime) {
        dateTime = combineDateTime(inputDate, inputTime);
        past = dateTime < startOfDay(new Date())
        useMagicBuckets = (!usesForecastTargets() && !past) || (usesForecastTargets() && Activity.isForecastEvent($activityContext) && editingMode)
        trainingAdvicePromise = refreshTrainingAdvice(); 
        if (chosenEntryTab === "magic" && !useMagicBuckets) chosenEntryTab = "activity"
    }

    let useMagicBuckets = false
    let magicBucketsFieldsAndData: MagicBucketsFieldsAndData = new MagicBucketsFieldsAndData(
      () => {
        magicBucketsFieldsAndData = magicBucketsFieldsAndData; // trigger reactivity
      }
    );
    let magicBucketsType: MagicBucketsType = 'workout';
    let targetsAreLowIntensity = true

    function setManualXATATargets(advice: any) {
        manualExerciseXss = round(advice.xss_goal, 1) ?? 0;
        manualExerciseXlss = round(advice.targetXSS.xlss, 1) ?? 0;
        manualExerciseXhss = round(advice.targetXSS.xhss, 1) ?? 0;
        manualExerciseXpss = round(advice.targetXSS.xpss, 1) ?? 0;
        manualExerciseFocus = advice.recommended_athlete ?? "Endurance";
        manualExerciseSpr = advice.recommended_spec_rating ?? "Mixed";
    }

    function setManualXFAITargets(exercise: any) {
        manualExerciseDuration = round(exercise.duration/60, 1);
        manualExerciseXss = round(exercise.xss, 1);
        manualExerciseXlss = round(exercise.xlss, 1);
        manualExerciseXhss = round(exercise.xhss, 1);
        manualExerciseXpss = round(exercise.xpss, 1);
        manualExerciseDistance = exercise.distance ? round(kmToUserDistanceUnits(exercise.distance), 1) : 0;
        manualExerciseFocus = exercise.focus ?? 'Endurance';
        manualExerciseSfd = exercise.sfd;
        manualExerciseSpr = exercise.spr ?? 'Pure';
        manualExerciseSp = exercise.sp;
    }

    function initMagicBuckets() {
      magicBucketsFieldsAndData?.initMagicBuckets();
      magicBucketsType = 'workout';
      targetsAreLowIntensity = true;
    }

    //There is only one instance of this svelte component across the whole calendar, so variables must be reinitialized properly
    export async function init(forDate, setIsLoadingCallback, useRecommended, openTo: EntryModes) {

        // Clear activity context from previous activity.
        // TODO: Should it be cleared when previous modal is closed, rather then when new modal is opened?
        $activityContext = null;

        initMagicBuckets();
        editingMode = false;
        editingForecast = false
        editingPlaceholder = false
        setIsLoading = setIsLoadingCallback
        selected_exercise = null;
        selected_path = null;
        hasPowerData = true
        activityType = sport_type;  
        manualExercisePath = null;
        manualExerciseDistance = 0;
        manualExerciseDuration = 0;
        manualExerciseName = null;
        manualExerciseFocus = "Endurance";
        manualExerciseSfd = null;
        manualExerciseDesc = null;
        manualExerciseSpr = "Mixed";
        manualExerciseSp = null;
        manualExerciseXss = 0;
        manualExerciseXlss = 0;
        manualExerciseXhss = 0;
        manualExerciseXpss = 0;
        originalDateTime = null;
        isAdditionalTraining = !useRecommended;

        inputDate = toDateInputString(forDate);
        if (isToday(forDate)) {
          let time = addHours(new Date(), 1);
          if (!isToday(time)) {
            time = endOfDay(forDate);
          }
          inputTime = toTimeInputString(time)
        } else {
          let time = await getMedianActivityStartTime(forDate);
          inputTime = toTimeInputStringHours(time);
        }
        onDateChange(inputDate, inputTime).then( async () => {
            if (!usesForecastTargets()) setManualXATATargets(await trainingAdvicePromise)   
        })

        chosenEntryTab = openTo ?? (editingForecast ? "workout" : "activity")
        open = true
    }

    // These variables are populated by initEdit (when initEdit is called for a forecast activity)
    let forecast_activities;
    let activities_3day;
    let training_status_collection;
    let target_event;
    let start_forecast;
    let spFocus_3day: SPFocus[];
    let lastBTDate: Date | null = null;
    let forecastInfo: ForecastActivityState | null = null
    let editingForecast = false
    let editingPlaceholder = false
    let originalDateTime: Date | null = null
    let forecastPromise: Promise<any> = new Promise(()=>{});

    let activityContext : Writable<any> = writable(null);
    setContext('modal_activity', activityContext);
    const pinnedState = 'pinned';

    let sport;
    export async function initEdit(forDate, editExercise, setIsLoadingCallback, openTo: EntryModes){

        initMagicBuckets()
        editExercise = {
            ...editExercise, 
            isPinned: Activity.isPinned(editExercise), 
            date_string: LocalDate.format(new Date(editExercise.start_date))
        }
        $activityContext = editExercise;
        sport = editExercise.sport;

        editingMode = true;
        setIsLoading = setIsLoadingCallback;
        hasPowerData = !(editExercise.hasPowerData==false)
        editingPlaceholder = editExercise.state?.includes('placeholder');
        editingForecast = editExercise.state?.includes('forecast') && !editExercise.state?.includes('completed');
        const editingManualEntry = editExercise.state?.includes('manualEntry');

        editExercisePath = editExercise.path;
        selected_path = editExercise.related_activity_id;
        
        if (editExercise.activityType) activityType = editExercise.type

        isAdditionalTraining = true
        if (usesForecastTargets(new Date(editExercise.start_date)) && editingForecast) {
            isAdditionalTraining = false

            const fromDate = addDays(new Date(editExercise.start_date), -1);

            forecastPromise = populateForecast('', fromDate).then(result => {
                forecast_activities = result?.forecast_activities
                activities_3day = result?.activities
                target_event = result?.target_event
                training_status_collection = result?.training_status_collection
                start_forecast = result?.start_forecast
                spFocus_3day = result.spFocus
                lastBTDate = result?.last_BT_date
                return result
            })
        }
        
        setManualXFAITargets(editExercise)
        if (!editingPlaceholder) {
            manualExercisePath = editExercise.path;//we store the edit path for manuals in the activity edit modal to append to id's for form validation
            manualExerciseName = editExercise.name;
            manualExerciseDesc = editExercise.description;
        } else {
            manualExercisePath = editExercise.path;
            manualExerciseName = null;
            manualExerciseDesc = null;
        }
        
        inputDate = toDateInputString(forDate);
        let startDate = new Date(editExercise.start_date);
        originalDate = startDate;
        inputTime = toTimeInputString(startDate);
        dateTime = combineDateTime(inputDate, inputTime);
        executeDateDebouncer()
        originalDateTime = dateTime

        chosenEntryTab = openTo ?
            openTo : editingManualEntry || (!hasPowerData && !editingPlaceholder && !(!isActivityCompleted(editExercise) && editExercise.xss === 0)) ?
            (editingForecast ? "workout" : "manual") : (editingForecast ? "workout" : "activity")
        open = true
    }

    async function getMedianActivityStartTime(date){
        const medians = $trainingMedians
        if(medians.dow[date.getDay()]?.all?.median_start_time != null)
            return medians.dow[date.getDay()].all.median_start_time;
        return medians.total.all.median_start_time;
    }


    $: canSubmit = (chosenEntryTab == "manual" && activityFormValid) || ((chosenEntryTab === "activity" || chosenEntryTab === "workout") && (selected_exercise || editingMode)) || (chosenEntryTab === "magic" && (magicBucketsFieldsAndData.mpaData || magicBucketsType === "autogen" || targetsAreLowIntensity && magicBucketsFieldsAndData.targets))
    async function submitHandler(){
        const isLoadingFunc = setIsLoading
        isLoadingFunc?.(true)
        if (editingMode && !selected_exercise && !restToggleState && chosenEntryTab === "activity") {
            open = false
            await deleteCalendarEvent(editExercisePath)
        } else if (chosenEntryTab === "magic" && magicBucketsType !== "manual") {

            autoGenWorkout({
                forDate: dateTime, 
                edit_id: $activityContext?.state?.includes('forecast') ? editExercisePath : null,
                bucketsInfo: magicBucketsType === "workout" ? {intervals: magicBucketsFieldsAndData.mpaData.intervals, challengeLevel: magicBucketsFieldsAndData.selectedChallengeLevel} : null,
            })

            open = false

        } else if (selected_exercise?.exerciseType?.toLowerCase() == 'session') {
            open = false
            await window.fetch(`session-template/${selected_exercise.template_id}/schedule`, {method: 'POST', 
            body: JSON.stringify({
                start_date: dateTime.toISOString()
            }),
            ...getRequest()});
        } else {
            if (!editingForecast) {
                const now = new Date()
                if ($activityContext != null) {
                    if (isActivityCompleted($activityContext)) {
                        if (dateTime > now) {
                            Xert.warning('<strong>warning:</strong> cannot move completed activity to the future')
                            isLoadingFunc?.(false)
                            return
                        }
                    } else if (Activity.isPlanned($activityContext)) {
                        if (dateTime < now) {
                            Xert.warning('<strong>Warning:</strong> Cannot move planned activity to the past')
                            isLoadingFunc?.(false)
                            return
                        }
                    }
                }
            }

            open = false
            let postData = {};
            postData['start_date'] = dateTime.toISOString();
            if(selected_exercise && (chosenEntryTab === "activity" || chosenEntryTab === "workout")){//selected exercises
                postData['manualExercise'] = false;
                postData['type'] = selected_exercise.exerciseType?.toLowerCase()
                postData['id'] = selected_exercise.path;
                postData['end_date'] = new Date(dateTime.getTime() + selected_exercise.duration*1000).toISOString();
            } else if (restToggleState) {
                postData = toggledRestActivityBody(dateTime)
            } else {//manual exercises
                postData['manualExercise'] = true
                if(chosenEntryTab ==="magic" && magicBucketsType === "manual") {
                    const focusSpecificity = await xssToFocusSpecificity(
                        magicBucketsFieldsAndData.signature, 
                        {xss: magicBucketsFieldsAndData.targets.xss, xlss: magicBucketsFieldsAndData.targets.xlss, xhss:magicBucketsFieldsAndData.targets.xhss, xpss: magicBucketsFieldsAndData.targets.xpss},
                        $userParams.athletes,
                    )
                    postData['sport'] = sport_type;
                    const rideType = sport_type === "Running" ? "Run" : "Ride"
                    if (targetsAreLowIntensity) {
                        postData['title'] = `XMB Endurance ${rideType}`
                        postData['duration'] = getEnduranceDurationDifficulty(magicBucketsFieldsAndData.targets.xlss).duration*60
                        postData['description'] = `Xert Magic Buckets Activity\nXSS Targets:　 🔵 ${round(magicBucketsFieldsAndData.targets.xlss)}　 🟡 ${round(magicBucketsFieldsAndData.targets.xhss, 1)}　 🔴 ${round(magicBucketsFieldsAndData.targets.xpss, 1)}`
                    } else {
                        postData['title'] = `XMB ${rideType} CL${magicBucketsFieldsAndData.selectedChallengeLevel}`
                        postData['duration'] = magicBucketsFieldsAndData.mpaData.summary.duration
                        postData['description'] = `Xert Magic Buckets Activity\nChallenge Level: ${magicBucketsFieldsAndData.selectedChallengeLevel}\nXSS Targets:　 🔵 ${round(magicBucketsFieldsAndData.targets.xlss)}　 🟡 ${round(magicBucketsFieldsAndData.targets.xhss, 1)}　 🔴 ${round(magicBucketsFieldsAndData.targets.xpss, 1)}`
                    }

                    postData['end_date'] = new Date(dateTime.getTime() + postData['duration']*1000/60).toISOString();
                    postData['xss'] = magicBucketsFieldsAndData.targets.xss
                    postData['xlss'] = magicBucketsFieldsAndData.targets.xlss
                    postData['xhss'] = magicBucketsFieldsAndData.targets.xhss
                    postData['xpss'] = magicBucketsFieldsAndData.targets.xpss
                    postData['specificity_rating'] = focusSpecificity.specificityRating
                    postData['sp'] = focusSpecificity.specificity
                    postData['focus'] = focusSpecificity.focus
                    postData['sfd'] = focusSpecificity.sfd
                } else {
                    postData['sport'] = activityType;
                    postData['end_date'] = new Date(dateTime.getTime() + parseInt(manualExerciseDuration)*1000).toISOString();
                    postData['distance'] = userDistanceUnitsToKm(manualExerciseDistance);
                    postData['duration'] = manualExerciseDuration*60;
                    postData['title'] = manualExerciseName;
                    postData['focus'] = manualExerciseFocus;
                    postData['sfd'] = manualExerciseSfd;
                    postData['description'] = manualExerciseDesc;
                    postData['specificity_rating'] = manualExerciseSpr;
                    postData['sp'] = manualExerciseSp;
                    postData['xss'] = manualExerciseXss;
                    postData['xlss'] = manualExerciseXlss;
                    postData['xhss'] = manualExerciseXhss;
                    postData['xpss'] = manualExerciseXpss;  
                }
                   
            }
            postData['options'] = {
                state: []
            }
            const today = new Date()
            if ((editingForecast && dateTime < startOfDay(today)) ||  (!editingForecast && dateTime < today)) {
                postData['options']['state'].push('completed')
            } else {
                postData['options'] = {
                    ...postData['options'],
                    planned: true,
                }
                postData['options']['state'].push('scheduled')
            }
            if (chosenEntryTab === "manual") {
                postData['options']['state'].push('manualEntry')
            } else {
                postData['options']['state'].push('recommended')
            }
            if (editingMode) {
                postData['options'] = {
                    ...postData['options'],
                    edit_id: editExercisePath,
                }
                if (editingForecast) {
                    postData['options']['state'].push('forecast')
                }
            }
            if (isAdditionalTraining) {
                postData['options']['state'].push('no_associate')
            }

            if($activityContext){
                if($activityContext.isPinned){
                    postData['options']['state'].push(pinnedState)
                }
                else{
                    postData['options']['state'] = postData['options']['state'].filter(s=>s!=pinnedState)
                }
                

                let lockEvent = new CustomEvent("lockEvent", {
                    bubbles: true,
                    detail:{
                        $activityContext
                    },
                });
                dispatchEvent(lockEvent);
            }
            await window.fetch('/createCalendarEvent', {method: 'POST', body: JSON.stringify(postData), ...getRequest()});
        }
        
        isLoadingFunc?.(false)
        dispatchReloadEvent(originalDate != null ? [dateTime, originalDate] : [dateTime], root);
    }
</script>

<Sheet.Root bind:open portal="#shadcn-ui-dialog-target">
    <Sheet.Content side="bottom" class={cn('flex flex-col min-w-0 h-[100dvh] lg:h-[97dvh]')}>
        <Sheet.Header class="border-b border-border">
            <Sheet.Title>
                {#if editingPlaceholder}
                    Choose
                {:else if editingMode}
                    Modify
                {:else if past}
                    Add
                {:else}
                    Plan
                {/if}
                {' '}
                {#if editingForecast}
                    my Training
                {:else}
                    an Activity
                {/if}
            </Sheet.Title>
        </Sheet.Header>

        <div class="h-full overflow-y-auto overflow-x-hidden" on:selectAndSave={submitHandler}>

            <div class="flex flex-wrap gap-x-8 gap-y-4 items-start mb-6 mt-2">
                <div class="">
                    <div class="font-medium mb-[0.95rem] text-sm">Training Status</div>
                    {#await trainingAdvicePromise}
                        <Skeleton class="w-[124px] h-6" />
                    {:then advice}
                        <TrainingStatus hideLeftLabel={true} trainingAdvice={advice} />
                    {/await}
                </div>
                <div class="space-y-1">
                    <Label for="selected-date">Date</Label>
                    <Input type="date" id="selected-date" bind:value={inputDate} disabled={editingForecast} on:change={executeDateDebouncer}/>
                </div>
                <div class="space-y-1">
                    <Label for="selected-time">Time</Label>
                    <Input type="time" id="selected-time" bind:value={inputTime} on:change={executeDateDebouncer}/>
                </div>
            </div>

            <Tabs.Root class="flex flex-col" bind:value={chosenEntryTab}>
                <Tabs.List class={cn("grid w-full", entryModeTabs.length > 3 ? (useMagicBuckets ? "grid-cols-4" : "grid-cols-3") : (useMagicBuckets ? "grid-cols-3" : "grid-cols-2"))}>
                    {#each entryModeTabs as tab}
                        {#if !(tab.value == "magic" && !useMagicBuckets)}
                          <Tabs.Trigger value={tab.value}>
                            <span class="sm:hidden">{tab.label.split(' ')[0]}</span>
                            <span class="hidden sm:inline">{tab.label}</span>
                          </Tabs.Trigger>
                        {/if}
                    {/each}
                </Tabs.List>
    
                <div class="flex flex-col md:flex-row gap-6">
                    {#if !forecastTargets || editingForecast}
                        <div class="md:w-1/2">
                            {#if !past && (!forecastTargets || editingForecast) && weather}
                                <div>
                                    <Weather {weather} {dateTime}></Weather>
                                </div>
                            {/if}
                            {#if editingForecast && xssTargetsResponse && isToday(dateTime)}
                                <div class='p-4 portlet light portlet-fit bordered'>
                                    <XssSummary {xssTargetsResponse} hideActions />
                                </div>
                            {/if}
                            {#await trainingAdvicePromise}
                                <div class="flex justify-center items-center flex-1 py-12">
                                    <div class="fas fa-circle-notch fa-spin flex-none" style="color: var(--color-xert-teal); font-size: 32px;"/>
                                </div>
                            {:then advice}
                                <div class="box-solid no-twp">
                                    <div class="portlet light portlet-fit bordered full-height-content full-height-content-scrollable">
                                        {#if forecastTargets && editingMode && editingForecast}
                                            {#await forecastPromise}
                                                <div class="flex justify-center items-center flex-1 py-12">
                                                    <div class="fas fa-circle-notch fa-spin flex-none" style="color: var(--color-xert-teal); font-size: 32px;"/>
                                                </div>
                                            {:then}
                                                <div class={cn((editingForecast && xssTargetsResponse && isToday(dateTime)) ? "hidden" : "")}>
                                                  <TrainingUpcomingCards bind:forecastInfo isModal={true} {myFitness} {forecast_activities} {training_status_collection} {target_event} {start_forecast} {spFocus_3day} {activities_3day} {lastBTDate} />
                                                </div>
                                                {#if forecastInfo}
                                                    <details class="md:hidden  px-[20px] pt-0 pb-4 mt-4">
                                                      <summary class="list-item cursor-pointer text-sm text-primary hover:underline">Training Explanation</summary>
                                                      <div class='mt-2'>
                                                        <ForecastDescription selectedMode={$trainingPlan?.selected_mode} {forecastInfo} {myFitness} />
                                                      </div>
                                                    </details>
                                                    <div class='hidden md:block px-[20px] pt-0 pb-4 mt-4'>
                                                        <ForecastDescription selectedMode={$trainingPlan?.selected_mode} {forecastInfo} {myFitness}/>
                                                    </div>
                                                {/if}
                                            {/await}
                                        {:else if !forecastTargets}
                                            <div class="portlet-title">
                                                <div class="title_container">
                                                    <span class="box_header">
                                                        Adaptive Training Advisor
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="training_status_and_gauge_container">
                                                <div class="training_info_block">
                                                    <div class="items">
                                                        <XataTrainingStatus trainingAdvice={advice}/>
                                                    </div>
                                                </div>
                                                <div class="flex justify-center items-center flex-1">
                                                    <div class="flex flex-col items-center justify-center flex-1">
                                                        <XssDeficitGauge training_advice={advice} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="hidden md:block col-xs-12 container" id="training_advisor_block">
                                                    <XataContent trainingAdvice={advice}/>
                                                </div>
                                            </div>
                                        {/if}
                                    </div>
                                </div>
                                {#if !past && !forecastTargets && dateTime != null}
                                    <div class="hidden md:block no-twp">
                                        <XataSlider {myFitness} {athlete} {workout_description} {program_weeks} {challenge_days} bind:atDate={dateTime}/>
                                    </div>
                                {/if}
                            {/await}
                        </div>
                    {/if}
        
                    <div class={cn(!forecastTargets || editingForecast ? "md:w-1/2" : "flex-1")}>

                        {#if editingForecast}
                            <Tabs.Content value="workout">
                                <div class="no-twp">
                                    <RecommendedTraining bind:isRestToggleState={restToggleState} bind:selected_exercise bind:selected_path calendarSelectedDate={dateTime} isCalendarPicker={true} bind:calendarPickerIsPast={past} {likeScore} {dislikeScore} {myFitness} {isAdditionalTraining} {sport} forcedPill={ReccTrainingPills[4]} />
                                </div>
                            </Tabs.Content>
                            <Tabs.Content value="activity">
                                <div class="no-twp">
                                    <RecommendedTraining bind:isRestToggleState={restToggleState} bind:selected_exercise bind:selected_path calendarSelectedDate={dateTime} isCalendarPicker={true} bind:calendarPickerIsPast={past} {likeScore} {dislikeScore} {myFitness} {isAdditionalTraining} {sport} forcedPill={{ label: 'Activity', value: 5, exerciseType: 'Activity', activityType: '' }} />
                                </div>
                            </Tabs.Content>
                        {:else}
                            <Tabs.Content value="activity">
                                <div class="no-twp">
                                    <RecommendedTraining bind:isRestToggleState={restToggleState} bind:selected_exercise={selected_exercise} bind:selected_path calendarSelectedDate={dateTime} isCalendarPicker={true} bind:calendarPickerIsPast={past} {likeScore} {dislikeScore} {myFitness} {isAdditionalTraining} {sport}/>
                                </div>
                            </Tabs.Content>
                        {/if}

                        <Tabs.Content value="magic">
                            <div class="box-solid">
                                <div class="portlet light portlet-fit bordered full-height-content full-height-content-scrollable">
                                    <div class="portlet-title">
                                        <div class="title_container">
                                            <span class="box_header">
                                                Generate Workout
                                            </span>
                                        </div>
                                    </div>
                                    <div class="px-[20px] py-[15px]">
                                        <MagicBucketsWorkout
                                          bind:fields={magicBucketsFieldsAndData}
                                          bind:magicBucketsType
                                          bind:targetsAreLowIntensity
                                        />
                                    </div>
                                </div>
                            </div>
                        </Tabs.Content>

                        <Tabs.Content value="manual">
                            <div class="box-solid">
                                <div class={`portlet light portlet-fit bordered full-height-content full-height-content-scrollable`}>
                                    <div class="portlet-title">
                                        <div class="title_container">
                                            <span class="box_header justify-items-start">Enter Activity Data</span>
                                        </div>
                                    </div>
                                    <div class="px-[20px] py-[15px]">
                                        <ActivityEdit {exercise} {myFitness} {activity_types} bind:exerciseDesc={manualExerciseDesc} bind:isValid={activityFormValid}
                                            bind:exercisePath={manualExercisePath} bind:exerciseName={manualExerciseName} bind:exerciseDuration={manualExerciseDuration} bind:exerciseXss={manualExerciseXss}
                                            bind:exerciseDistance={manualExerciseDistance} bind:exerciseFocus={manualExerciseFocus} bind:exerciseFocusDuration={manualExerciseSfd} bind:exerciseSpr={manualExerciseSpr} bind:exerciseSp={manualExerciseSp} bind:activityType
                                            bind:exerciseXlss={manualExerciseXlss} bind:exerciseXhss={manualExerciseXhss} bind:exerciseXpss={manualExerciseXpss}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Tabs.Content>

                    </div>
                </div>
    
            </Tabs.Root>
        </div>

        <Sheet.Footer class="border-t border-border">
            <Button variant="outline" value="save" type="submit" class="btn btn-default pull-right bottom-btn mt-2.5" on:click={submitHandler} disabled={!canSubmit}>
                Save
            </Button>
        </Sheet.Footer>

    </Sheet.Content>
</Sheet.Root>
